import { css } from 'twind/css'

export const dialingInfoText = css({
  color: 'var(--gray-3)',
})

export const dialingTopSection = css({
  background: 'var(--gray-9)',
})

export const agentImage = css({
  objectFit: 'cover',
  objectPosition: 'top',
  height: '88px',
  width: '88px',
})

export const queuePositionText = css({
  color: 'var(--white)',
})

export const queuePositionNumber = css({
  background: 'var(--white)',
  color: 'var(--blk1)',
  width: '24px',
  height: '24px',
})

export const intentDesciptionText = css({
  color: 'var(--white)',
})
